import one from '../assets/png/proj/one.png'
import two from '../assets/png/proj/two.png'
import three from '../assets/png/proj/three.png'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Neom',
        projectDesc: 'A FireBase Authentication App.',
        tags: ['Flutter', 'Dart' ,'Firebase', 'Git', 'Android Studio'],
        code: 'https://github.com/manvi-singhal/Neom',
        demo: 'https://github.com/manvi-singhal/Neom',
        image: one,
    },
    {
        id: 2,
        projectName: 'Bank Management System',
        projectDesc: 'The Bank Management System is based on a concept to generate and maintain daily payment transactions with the customer’s account. ',
        tags: ['C', 'C++','VSCode','GitHub'],
        code: 'https://github.com/manvi-singhal/Bank-Management-System',
        demo: 'https://github.com/manvi-singhal/Bank-Management-System',
        image: two,
    },
    {
        id: 3,
        projectName: 'Erlang Pattern',
        projectDesc: 'This project is a program in Erlang language that takes an integer input N and prints the above pattern upto ‘N’ digits.',
        tags: ['Erlang', 'OTP','GitHub'],
        code: 'https://github.com/manvi-singhal/TeamRudra',
        demo: 'https://github.com/manvi-singhal/TeamRudra',
        image: three,
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/